import { render, staticRenderFns } from "./FullScreenToggler.vue?vue&type=template&id=4d983516&"
import script from "./FullScreenToggler.vue?vue&type=script&lang=js&"
export * from "./FullScreenToggler.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenToggler.vue?vue&type=style&index=0&id=4d983516&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports